import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const MobilSaglikAraciPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = 'Mobil Sağlık Aracı Adana Mersin Hatay Osmaniye | ASSA OSGB';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adana OSGB, Mersin OSGB, Hatay OSGB, Osmaniye OSGB mobil sağlık aracı hizmeti. İşyerinizde sağlık muayenesi, laboratuvar testleri. ASSA OSGB mobil sağlık hizmetleri.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adana mobil sağlık, Mersin mobil sağlık, Hatay mobil sağlık, Osmaniye mobil sağlık, OSGB mobil sağlık aracı');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/laboratuvar/mobil-saglik-araci`);
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "ASSA OSGB Mobil Sağlık Aracı",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde mobil sağlık aracı hizmeti",
      "provider": {
        "@type": "Organization",
        "name": "ASSA OSGB",
        "telephone": "0850 346 2772",
        "email": "assa@assaisg.com"
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Adana"
        },
        {
          "@type": "City",
          "name": "Mersin"
        },
        {
          "@type": "City",
          "name": "Hatay"
        },
        {
          "@type": "City",
          "name": "Osmaniye"
        }
      ],
      "serviceType": "Mobil Sağlık Aracı",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/laboratuvar/mobil-saglik-araci`
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FloatingButtons />

      {/* Hero Section */}
      <section 
        className="pt-24 pb-16 bg-cover bg-center relative"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/4a1af970487c683eb0d9372e82cdff84.jpg')`
        }}
      >
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Mobil Sağlık Aracı
            </h1>
            <p className="text-xl mb-8">
              <strong>Adana OSGB</strong>, <strong>Mersin OSGB</strong>, <strong>Hatay OSGB</strong> ve <strong>Osmaniye OSGB</strong> bölgelerinde mobil sağlık aracımızla işyerinize geliyoruz. Çalışanlarınızın sağlık muayenelerini yerinde gerçekleştiriyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Mobil Sağlık Aracı Hizmetlerimiz
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Service Card 1 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-stethoscope-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Genel Sağlık Muayenesi</h3>
                <p className="text-gray-600">
                  İşyerinizde tam donanımlı sağlık muayenesi. <strong>Adana mobil sağlık</strong> hizmetimizle zaman tasarrufu sağlayın.
                </p>
              </div>

              {/* Service Card 2 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-test-tube-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Laboratuvar Testleri</h3>
                <p className="text-gray-600">
                  Kan tahlili, idrar tahlili ve diğer laboratuvar testleri. <strong>Mersin OSGB mobil sağlık</strong> standartlarında hizmet.
                </p>
              </div>

              {/* Service Card 3 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-heart-pulse-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">EKG ve Kardiyoloji</h3>
                <p className="text-gray-600">
                  Elektrokardiyografi ve kalp sağlığı testleri. <strong>Hatay OSGB</strong> bölgesinde mobil kardiyoloji hizmeti.
                </p>
              </div>

              {/* Service Card 4 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-lungs-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Solunum Testleri</h3>
                <p className="text-gray-600">
                  Spirometri ve akciğer fonksiyon testleri. <strong>Osmaniye mobil sağlık</strong> aracımızda tam donanım.
                </p>
              </div>

              {/* Service Card 5 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-eye-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Görme ve İşitme Testleri</h3>
                <p className="text-gray-600">
                  Görme keskinliği, renk körlüğü ve işitme testleri. <strong>Adana OSGB</strong> mobil sağlık hizmeti.
                </p>
              </div>

              {/* Service Card 6 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-file-text-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sağlık Raporu Düzenleme</h3>
                <p className="text-gray-600">
                  İşe giriş ve periyodik sağlık raporları. <strong>Mersin mobil sağlık</strong> aracımızda anında rapor.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <img 
                  src="https://readdy.ai/api/search-image?query=Interior%20of%20modern%20mobile%20health%20clinic%2C%20medical%20equipment%20inside%20ambulance%2C%20professional%20healthcare%20workspace%2C%20clean%20medical%20examination%20room%20in%20vehicle%2C%20advanced%20diagnostic%20tools%2C%20mobile%20laboratory%20setup%2C%20sterile%20medical%20environment&width=600&height=400&seq=mobile-health-interior-001&orientation=landscape"
                  alt="Mobil Sağlık Aracı İç Görünüm"
                  className="rounded-xl shadow-lg object-cover w-full h-80"
                />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Mobil Sağlık Aracının Avantajları
                </h2>
                <p className="text-gray-600 mb-6">
                  <strong>ASSA OSGB Mobil Sağlık Aracı</strong> ile <strong>Adana</strong>, <strong>Mersin</strong>, <strong>Hatay</strong> ve <strong>Osmaniye</strong> bölgelerinde işyerlerinize geliyoruz.
                </p>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-1 mr-3">
                      <i className="ri-check-line text-blue-600 text-sm"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">Zaman Tasarrufu</h4>
                      <p className="text-gray-600">Çalışanlarınız işyerinden ayrılmadan sağlık muayenesi olur</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-1 mr-3">
                      <i className="ri-check-line text-blue-600 text-sm"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">Tam Donanımlı Araç</h4>
                      <p className="text-gray-600">Hastane standartlarında tıbbi ekipman ve laboratuvar</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-1 mr-3">
                      <i className="ri-check-line text-blue-600 text-sm"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">Uzman Sağlık Ekibi</h4>
                      <p className="text-gray-600">Deneyimli doktor, hemşire ve sağlık teknisyenleri</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-1 mr-3">
                      <i className="ri-check-line text-blue-600 text-sm"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">Hızlı Sonuç</h4>
                      <p className="text-gray-600">Anında test sonuçları ve rapor düzenleme</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-1 mr-3">
                      <i className="ri-check-line text-blue-600 text-sm"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">Maliyet Avantajı</h4>
                      <p className="text-gray-600">Toplu muayene ile uygun fiyat avantajı</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Regional Coverage */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Hizmet Bölgelerimiz
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Adana Mobil Sağlık</h3>
                <p className="text-gray-600">
                  Adana ve çevresinde <strong>mobil sağlık aracı</strong> hizmeti
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Mersin Mobil Sağlık</h3>
                <p className="text-gray-600">
                  Mersin bölgesinde işyerinize <strong>mobil sağlık</strong> hizmeti
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Hatay Mobil Sağlık</h3>
                <p className="text-gray-600">
                  Hatay'da yerinde <strong>sağlık muayenesi</strong> hizmeti
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Osmaniye Mobil Sağlık</h3>
                <p className="text-gray-600">
                  Osmaniye'de <strong>mobil sağlık aracı</strong> desteği
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Mobil Sağlık Hizmeti Süreci
            </h2>

            <div className="grid md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">1</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Randevu Planlama</h3>
                <p className="text-gray-600">İşyeriniz için uygun tarih ve saat belirleme</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">2</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Araç Gelişi</h3>
                <p className="text-gray-600">Mobil sağlık aracımız işyerinize geliyor</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">3</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Muayene ve Testler</h3>
                <p className="text-gray-600">Çalışanlarınızın sağlık muayenesi yapılıyor</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">4</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Rapor Teslimi</h3>
                <p className="text-gray-600">Sağlık raporları anında düzenleniyor</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Mobil Sağlık Aracı Donanımı
            </h2>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-heart-pulse-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Tıbbi Cihazlar</h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-blue-600 mr-2 mt-1"></i>
                    <span>EKG Cihazı</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-blue-600 mr-2 mt-1"></i>
                    <span>Spirometre</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-blue-600 mr-2 mt-1"></i>
                    <span>Odyometre</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-blue-600 mr-2 mt-1"></i>
                    <span>Görme Test Cihazı</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-50 rounded-xl p-6">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-test-tube-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Laboratuvar Ekipmanı</h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-blue-600 mr-2 mt-1"></i>
                    <span>Kan Alma Ünitesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-blue-600 mr-2 mt-1"></i>
                    <span>Santrifüj Cihazı</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-blue-600 mr-2 mt-1"></i>
                    <span>Hızlı Test Kitleri</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-blue-600 mr-2 mt-1"></i>
                    <span>Soğuk Zincir Sistemi</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-50 rounded-xl p-6">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-computer-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Dijital Altyapı</h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-blue-600 mr-2 mt-1"></i>
                    <span>Elektronik Kayıt Sistemi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-blue-600 mr-2 mt-1"></i>
                    <span>Online Rapor Sistemi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-blue-600 mr-2 mt-1"></i>
                    <span>Dijital Arşivleme</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-blue-600 mr-2 mt-1"></i>
                    <span>Güvenli Veri Aktarımı</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Mobil Sağlık Aracı Hizmeti Almak İster misiniz?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              <strong>Adana OSGB</strong>, <strong>Mersin OSGB</strong>, <strong>Hatay OSGB</strong> ve <strong>Osmaniye OSGB</strong> bölgelerinde mobil sağlık aracımızla işyerinize geliyoruz.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/iletisim" 
                className="bg-white text-blue-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                Hemen İletişime Geçin
              </Link>
              <a 
                href="tel:08503462772" 
                className="bg-blue-700 text-white px-8 py-4 rounded-lg font-bold hover:bg-blue-800 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                0850 346 2772
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MobilSaglikAraciPage;
